import React, { FC } from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import Stack from "../stack/Stack";
import Typography from "../typography/Typography";
import { Tick } from "../icon/icons/Tick";
import Html from "../html/Html";
import { ThemeColorsKeys } from "../../styles/tokens/colors";

// Interface

export interface TickListProps {
  items: TickListItemProps[];
  tickColour: ThemeColorsKeys;
}

export interface TickListItemProps {
  heading: string;
  text?: string;
}

interface StyledTickListItemProps {
  hasText?: boolean;
}

// Styles

export const StyledTickList = styled.ul`
  ${({ theme: { space } }) => css`
  `};
`;

const StyledTickListItem = styled.li<StyledTickListItemProps>`
  ${({ theme: { space, borders }, hasText }) => css`
    display: flex;
    gap: ${space.xxSmall};

    & + & {
      border-top: 1px solid currentColor;
      margin-top: ${hasText ? space.fluidSmallToMedium : space.xSmall};
      padding-top: ${hasText ? space.fluidSmallToMedium : space.xSmall};
    }
  `};
`;

// JSX

export const TickList: FC<TickListProps> = ({ items, tickColour, ...rest }) => {
  // Work out if the any of the items have text
  const hasText = items.some(({ text }) => text);

  return (
    <StyledTickList {...rest}>
      {items?.map(({ heading, text }, index) => (
        <StyledTickListItem key={index} hasText={hasText}>
          <Tick color={tickColour || 'green'} />
          <Stack gap="xSmall">
            {heading && (
              <Typography
                component="h3"
                variant={text ? "secondaryHeadingSmallBold" : "bodyBold"}
              >
                {heading}
              </Typography>
            )}
            {text && <Html>{text}</Html>}
          </Stack>
        </StyledTickListItem>
      ))}
    </StyledTickList>
  );
};

export default TickList;
